import React from "react";
import propTypes from "prop-types";
import Link from "gatsby-link";
import { Col, Row } from "reactstrap";
import styled, { css } from "react-emotion";

export default class CallButton extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Row>
        <Col md="12">
          <a className="calltobutton" href={this.props.link}>{this.props.linktext}</a>
        </Col>
      </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CallButton.js